import { objectfyArray } from "../helpers/objectfyArray";
import { omit } from "lodash";
import _ from "lodash";

/* {
	"userId":"9104",
	"appId":"4405",
	"cartItems":[
        {
            "purchaseItemId":"3052",
            "quantity":1,
            "additionalOptionSelections":
            [
                {
                    "additionalOptionsGroupId":2,
                    "additionalOptionItemSelections":[
                        {
                            "selectedAdditionalItemId":102,
                            "quantity":1
                        },
                        {
                            "selectedAdditionalItemId":103,
                            "quantity":1
                        }
                    ]
                },
                {
                    "additionalOptionsGroupId":52,
                    "additionalOptionItemSelections":[
                        {
                            "selectedAdditionalItemId":55,
                            "quantity":1
                        }
                    ]
                }
            ]
        }
    ],
    "customerAdditionalComments":"Thanks for your time! I'm looking forward to this.",
    "templateId":"8280",
    "clientCalculatedSubtotal":8079,
    "customerTip":"1000",
    "clientTotal":9079,
    "platformType":"WEB"
}

*/

const cart = (
  state = {
    cartItems: [],
    clientCalculatedSubtotal: 0,
    customerAdditionalComments: "",
    orderDeliveryType: "",
    deliveryCost: 0,
    cartQty: 0,
    clientTotal: 0,
    orderDeliveryAddressId: null,
    paymentMethod: {},
    address: null,
    platformType: "WEB",
    orderCustomerInfo: {
      email: "",
      firstName: "",
      lastName: "",
      phone: "",
    },
  },
  action
) => {
  Object.freeze(state);
  let newState;

  switch (action.type) {
    case "UDPATE_ITEM_IN_CART":
      newState = { ...state };

      newState.cartQty -= action.oldItem.quantity;
      newState.clientCalculatedSubtotal -= action.oldItem.subtotal;

      newState.cartQty += action.storeItem.quantity;
      newState.clientCalculatedSubtotal += action.storeItem.subtotal;

      newState.cartItems[action.index] = action.storeItem;
      return newState;
    case "ADD_TO_CART":
      // Logic for adding item to cart
      // increase overall cart qty
      // console.log("adding to cart redux store");
      // console.dir(action.storeItem);
      newState = { ...state };
      // console.log("current state");
      // console.dir(newState);
      newState.cartQty += action.storeItem.quantity;
      newState.clientCalculatedSubtotal += action.storeItem.subtotal;

      newState.cartItems.push(action.storeItem);
      return newState;
    case "REMOVE_FROM_CART":
      newState = {
        ...state,
      };

      let itemQty = action.storeItem.quantity;
      let itemSubtotal = action.storeItem.subtotal;

      newState.cartQty -= itemQty;
      newState.clientCalculatedSubtotal -= itemSubtotal;

      let cartItems = newState.cartItems;
      cartItems.splice(action.index, 1);
      // console.log("isEmpty: " + !purchaseItems);
      if (!cartItems)
        return {
          cartItems: [],
          clientCalculatedSubtotal: 0,
          customerAdditionalComments: "",
          orderDeliveryType: "",
          deliveryCost: 0,
          cartQty: 0,
          clientTotal: 0,
          orderDeliveryAddressId: null,
          paymentMethod: {},
          address: null,
          platformType: "WEB",
          orderCustomerInfo: {
            email: "",
            firstName: "",
            lastName: "",
            phone: "",
          },
        };
      newState.cartItems = cartItems;

      return newState;
    case "REMOVE_ITEM_FROM_CART":
      newState = {
        ...state,
      };
      // console.log(newState.cartItems[action.storeItem.id]);
      let qty = newState.cartItems[action.storeItem.id];
      let subtotal = qty * action.storeItem.price;

      newState.cartQty -= qty;
      newState.clientCalculatedSubtotal -= subtotal;

      let items = newState.cartItems;
      delete items[action.storeItem.id];

      newState.cartItems = items;

      return newState;

    case "REMOVE_CART":
      return {
        cartItems: [],
        clientCalculatedSubtotal: 0,
        customerAdditionalComments: "",
        orderDeliveryType: "",
        deliveryCost: 0,
        cartQty: 0,
        clientTotal: 0,
        orderDeliveryAddressId: null,
        paymentMethod: {},
        address: null,
        platformType: "WEB",
        orderCustomerInfo: {
          email: "",
          firstName: "",
          lastName: "",
          phone: "",
        },
      };

    case "UPDATE_PRODUCT_QTY":
      newState = {
        ...state,
      };

      // console.log("Updating cartItem qty");
      // console.dir(action.cartItem);
      // console.log("old qty: " + action.qty);

      const basePrice = action.cartItem.subtotal / action.qty;
      // console.log("calculated base price: " + basePrice);
      // console.log(
      //   "calculating new subtotal with new qty: " + action.cartItem.quantity
      // );
      const newCartItemSubtotal = basePrice * action.cartItem.quantity;
      // console.log(newCartItemSubtotal);

      // // subtract old qty and item subtotal
      newState.cartQty -= action.qty;
      newState.clientCalculatedSubtotal -= action.cartItem.subtotal;

      //   // UPDATE
      action.cartItem.subtotal = newCartItemSubtotal;
      newState.cartItems[action.index] = action.cartItem;

      // // add new qty and item subtotal

      newState.cartQty += action.cartItem.quantity;
      newState.clientCalculatedSubtotal += action.cartItem.subtotal;

      return {
        ...newState,
      };
    case "SET_DELIVERY_METHOD":
      newState = {
        ...state,
      };
      newState.orderDeliveryType = action.orderDeliveryType;
      newState.deliveryCost = action.deliveryCost;
      newState.clientTotal =
        newState.clientCalculatedSubtotal + action.deliveryCost;
      return newState;
    case "UPDATE_CUSTOMER_INFO":
      newState = {
        ...state,
      };
      newState.orderCustomerInfo = action.orderCustomerInfo;
      return newState;

    case "UPDATE_CLIENT_TOTAL":
      newState = {
        ...state,
      };
      newState.clientTotal = action.clientTotal;
      return newState;

    case "UPDATE_ADDITIONAL_COMMENTS":
      newState = {
        ...state,
      };
      newState.customerAdditionalComments = action.comments;
      return newState;
    case "UPDATE_ADDRESS":
      newState = {
        ...state,
      };
      newState.orderDeliveryAddressId = action.id;
      return newState;
    case "UPDATE_ADDRESS_OBJECT":
      newState = {
        ...state,
      };
      newState.address = action.address;
      return newState;
    case "UPDATE_PAYMENT_METHOD":
      newState = {
        ...state,
      };
      newState.paymentMethod = action.method;
      return newState;

    case "REMOVE_PAYMENT_METHOD":
      newState = {
        ...state,
      };
      newState.paymentMethod = {};
      return newState;
    default:
      return state;
  }
};

export default cart;
